import styled from "styled-components/macro";

import { viewport, sections } from "../../common/config";

export const Section = styled.section(({ $height, $align }: {
  $height: number, //vh
  $align: "start" | "end"
}) => `
  position: relative;
  z-index: 3;

  height: ${$height}vh;
  width: ${sections.width.xs}vw;

  display: flex;
  align-items: center;
  justify-content: start;

  @media screen and (min-width: ${viewport.md}) {
    width: ${sections.width.md}vw;
    justify-content: ${$align};
  }

  @media screen and (min-width: ${viewport.xl}) {
    width: ${sections.width.xl}vw;
  }
`);

export const Container = styled.div(({ $primary = false }: { $primary?: boolean }) => `
  position: ${$primary ? "relative" : "absolute"};
  left: ${$primary ? "unset" : "100%"}; 

  flex-direction: column;
  
  width: 60vw;
  max-width: 550rem;

  @media screen and (min-width: ${viewport.md}) {
    padding: 0 30rem;
  }
`);

export const Title = styled.h3`
  font-size: 25rem;

  @media screen and (min-width: ${viewport.md}) { font-size: 28rem }
  @media screen and (min-width: ${viewport.lg}) { font-size: 32rem }
`;

export const Subtitle = styled.h4`
  font-size: 35rem;
  margin: 10rem 0;

  @media screen and (min-width: ${viewport.md}) { font-size: 40rem }
  @media screen and (min-width: ${viewport.lg}) { font-size: 45rem }
`;

export const Description = styled.p`
  @media screen and (min-width: ${viewport.md}) { font-size: 20rem }
`;